<script setup>
import { computed } from 'vue'
import { Link, router, usePage } from '@inertiajs/vue3'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@codinglabsau/gooey'
import {
  UserIcon,
  LogOutIcon,
  ShieldAlertIcon,
  HeartIcon,
  MessageSquareText
} from 'lucide-vue-next'
import UserAvatar from '@/Components/Users/UserAvatar.vue'

const user = computed(() => usePage().props.auth.user)

const tabs = computed(() => {
  return [
    {
      name: 'Profile',
      icon: UserIcon,
      href: route('account.show'),
      current: route().current('account.show'),
      update: false,
    },
    {
      name: 'Supporters Club',
      icon: HeartIcon,
      href: route('account.billing.show'),
      current: route().current('account.billing.*'),
      update: false,
    },
    {
      name: 'Messages',
      icon: MessageSquareText,
      href: route('messages.show'),
      current: route().current('messages.*'),
      update: user.value.unread_conversations.unread_messages_count > 0,
    },
    {
      name: 'Verify Email',
      icon: ShieldAlertIcon,
      href: route('verification.notice'),
      update: true,
      hidden: user.value.verified,
    },
  ]
})
</script>

<template>
  <DropdownMenu v-if="user">
    <DropdownMenuTrigger class="cursor-pointer">
      <UserAvatar :user="user" small />
    </DropdownMenuTrigger>

    <DropdownMenuContent class="w-56">
      <DropdownMenuLabel>
        {{ user.name ?? '' }}
      </DropdownMenuLabel>

      <DropdownMenuSeparator />

      <DropdownMenuGroup>
        <template
          v-for="tab in tabs"
          :key="tab.name"
        >
          <DropdownMenuItem
            v-if="!tab.hidden"
          >
            <Link
              class="flex items-center w-full"
              :href="tab.href"
            >
              <div class="mr-2">
                <component :is="tab.icon" class="size-4" />
              </div>

              <span class="grow">{{ tab.name }}</span>

              <div v-if="tab.update">
                <div class="size-2 rounded-full bg-red-500" />
              </div>
            </Link>
          </DropdownMenuItem>
        </template>
      </DropdownMenuGroup>

      <DropdownMenuItem @click="router.post(route('logout'))">
        <LogOutIcon class="mr-2 size-4" />

        <span>Log out</span>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>

  <div
    v-else
    class="flex items-center justify-center space-x-4 text-sm font-medium md:flex-row md:divide-x md:divide-y-0"
  >
    <Link
      rel="nofollow"
      :href="route('login')"
      class="border-transparent font-medium text-gray-500 hover:border-link-hover hover:text-link"
    >
      Login
    </Link>

    <Link
      rel="nofollow"
      :href="route('register')"
      class="border-transparent font-medium text-gray-500 hover:border-link-hover hover:text-link"
    >
      Register
    </Link>
  </div>
</template>
